import { GeneralState } from './types';

export const state: GeneralState = {
    config: {}
};
